export default __webpack_public_path__ + "static/media/3 dots button.92910763.svg";